export const LOAD_SEED_ARRAY_SUCCESS = 'LOAD_SEED_ARRAY_SUCCESS';
export const loadSeedArraySuccess = (seeds) => ({
  type: LOAD_SEED_ARRAY_SUCCESS,
  payload: { seeds },
});
export const LOAD_SEEDS_IN_PROGRESS = 'LOAD_SEEDS_IN_PROGRESS';
export const loadSeedsInProgress = () => ({
  type: LOAD_SEEDS_IN_PROGRESS,
});
